<span #menuOptionsWrapper>
    <ng-template #menuContents>
        <div class="menu-options-title" *ngIf="title !== undefined">
            {{ title }}
        </div>
        <div
            [class]="
                'button-container' +
                (option.enabled === false ? ' menu-option-button-disabled' : '')
            "
            *ngFor="let option of menuOptions.options"
            (mouseenter)="hoverOption($event, option)">
            <a-button
                width="100%"
                [type]="isMenuOption(option.data) ? 'with-right-chevron' : ''"
                [class]="
                    'menu-option-button ' +
                    (option.buttonClass
                        ? 'menu-option-button-' + option.buttonClass
                        : '') +
                    ' '
                "
                *ngIf="!option.loading"
                [label]="option.text"
                [icon]="option.icon"
                [loading]="option.iconLoading === true"
                [disabled]="option.enabled === false"
                [iconWidth]="option.iconWidth"
                [iconHeight]="option.iconHeight"
                (click)="clickOnOption(option, $event)"></a-button>

            <div class="loader" *ngIf="option.loading"></div>
        </div>
    </ng-template>

    <div
        *ngIf="!isMobileSheet"
        class="menu-background"
        id="menu-options"
        #menuOptionsContainer
        [ngStyle]="{ width: width ? width + 'px' : 'auto' }"
        [style.left.px]="menuOptions.coordinates.x - 3"
        [style.top.px]="menuOptions.coordinates.y - 3">
        <ng-container *ngTemplateOutlet="menuContents"></ng-container>
    </div>

    <ng-template #mobileSheetTemplate>
        <div
            class="menu-background mobile-context-sheet-surface"
            id="menu-options"
            #menuOptionsContainer
            mobileContextSheetDrag
            [class.mobile-context-sheet-open]="mobileSheetOpen"
            [class.mobile-context-sheet-closing]="mobileSheetClosing"
            (mobileContextSheetDismiss)="requestClose()">
            <button
                type="button"
                class="mobile-context-sheet-handle"
                aria-label="Dismiss menu"></button>
            <div class="mobile-context-sheet-scroll">
                <ng-container *ngTemplateOutlet="menuContents"></ng-container>
            </div>
        </div>
    </ng-template>

    <menu-options
        *ngIf="
            hoveredOption !== undefined &&
            isMenuOption(hoveredOption.option.data)
        "
        [menuOptions]="createMenuOptions()"
        [width]="getWidth()"
        [title]="hoveredOption.option.subtitle"
        (close)="closeSubmenu($event)"></menu-options>
</span>
